export enum RoutesEnum {
  Home = '/v3/',
  HomeAuth = '/v3/auth',

  Auth = '/v3/auth',
  AuthRecoveryPassword = '/v3/auth/recovery-password',
  AuthResetPassword = '/v3/auth/reset-password',

  Contracting = '/v3/contracting',
  ContractingList = '/v3/contracting/list',
  ContractingOnline = '/v3/online/contracting',
  SellersRanking = '/v3/sellers-ranking',
  SellersRankingList = '/v3/sellers-ranking/list',
  Online = '/v3/online',
  PaymentsList = '/v3/payments/list',
  Payments = '/v3/payments',

  Products = '/v3/products',
  ProductsList = '/v3/products/list',

  Stores = '/v3/stores',
  StoresList = '/v3/stores/list',
  Receipt = 'receipt-pdf',
  ContractingPDF = 'contracting-pdf',
  CreateStore = '/v3/stores/create',
  Seller = '/v3/seller',
  SellerList = '/v3/seller/list',

  Groups = '/v3/groups',
  GroupsList = '/v3/groups/list',
}

export const GO_BACK: number = -1;
export const GO_BACK_TWO_PAGES: number = -2;
export const GO_BACK_THREE_PAGES: number = -3;
export const GO_BACK_FOUR_PAGES: number = -4;
export const GO_BACK_FIVE_PAGES: number = -5;
